// @ts-nocheck
import React, { Dispatch, SetStateAction, useState } from 'react';
import { Button, Card, FormHelperText, IconButton, InputAdornment, Link, Stack, TextField, Typography, CircularProgress } from '@mui/material'
import { Icon } from '@iconify/react';
import { blue, btnTextColor, secondary } from '../../../theme/palette';
import { FormData } from '../models/loginDto';
import { useDispatch } from 'react-redux';
import { isLoginFunc } from '../../../../store/slices/login';
import { useLoginMutation } from '../services/services';
import { globalVal } from '../../../common/ConstantColors';
import { useNavigate } from 'react-router-dom';
import { ensureLatestAppVersion } from '../../../hooks/useAppVersionCheck';

const LoginForm: React.FC = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState<FormData>({
        mail: '',
        password: '',
        ip: "1.1.1.1",
        mailError: false,
        passwordError: false,
        loginError: '',
    });
    const [login, { isLoading }] = useLoginMutation();

    const { mail, password, mailError, passwordError, loginError } = formData;
    const dispatch = useDispatch();

    const isValidEmail = (email: string) => {
        // Yukarıdaki verdiğimiz regex ile e-posta doğrulaması yapın
        const emailRegex = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;
        if (email !== "" && !emailRegex.test(email)) {
            return ('Geçerli bir e-posta adresi girin.')
        }
        return false
    };

    const handleChange = (e: any) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value,
            [`${id}Error`]: id === 'mail' ? isValidEmail(value) : ""/*  validatePassword(value) */,
        });
    }


    const handleSubmit = async (e: any) => {
        e.preventDefault();
        globalVal.isLoggedOut = false;
        // Form validasyonu
        if (isLoading || (mailError) || (passwordError)) {
            return;
        }
        try {
            localStorage.setItem("email", mail)
            localStorage.removeItem('accessToken');
            localStorage.removeItem('verifyToken');
            let response: any = await login({ email: mail, password: password, ip: "1.1.1.1" }).unwrap();
            if (response.success) {
                dispatch(isLoginFunc(false));
                const reloading = await ensureLatestAppVersion(undefined, '/login?step=verify');
                if (reloading) return;
                navigate('/login?step=verify', { replace: true });
            }
        } catch (error: any) {
            console.log('error', error)
            if (error?.status === 419) {
                localStorage.setItem("verifyToken", error.data.data.token)
                navigate('/login?step=new-password');
            }
        }
    };

    const renderForm = (
        <form onSubmit={handleSubmit}>

            <Stack spacing={3}>
                <Typography variant="h4" sx={{ color: secondary.blue, textAlign: "center" }}>
                    Hoş geldiniz!
                </Typography>
                <TextField
                    name="mail"
                    label="E-posta"
                    id="mail"
                    required
                    onChange={handleChange}
                />
                <FormHelperText style={{ color: 'red', height: "20px", marginTop: "14px", marginLeft: "10px" }}>{mailError}</FormHelperText>
                <Link variant="subtitle2" underline="hover" sx={{ marginLeft: "auto", textDecoration: "none", cursor: "pointer", color: secondary.blue, marginTop: "0 !important", display: "flex", justifyContent: "end" }} onClick={() => !isLoading && navigate('/login?step=forgot')}>
                    Şifremi Unuttum
                </Link>
                <TextField
                    name="password"
                    label="Şifre"
                    id="password"
                    required
                    type={showPassword ? 'text' : 'password'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                    <Icon color={blue[900]} icon={!showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    onChange={handleChange}
                />
                <FormHelperText style={{ color: 'red', height: "40px", marginTop: "14px", marginLeft: "10px" }}>{passwordError}</FormHelperText>

            </Stack>

            <Button
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                disabled={isLoading}
                sx={{ color: `${btnTextColor} !important` }}
            >
                {isLoading ? <CircularProgress sx={{ margin: "auto", color: "white", height: "30px !important", width: "30px !important" }} /> : 'Giriş'}
            </Button>
            {loginError}
        </form>
    );

    return (
        <div>
            <Stack className="animate__animated animate__zoomIn" alignItems="center" justifyContent="center" >
                <Card
                    sx={{
                        p: 5,
                        m: 10,
                        width: 1,
                        maxWidth: 420,
                    }}>
                    {renderForm}
                </Card>
            </Stack>
        </div>
    )
}

export default LoginForm